import {
  NavigateFunction,
  NavigateOptions,
  useNavigate as useRouterNavigate
} from 'react-router-dom';
import { getFullPath } from '../utilities';

/** Custom version of @see useRouterNavigate that adds query parameters to string paths. */
export function useCustomNavigate(): NavigateFunction {
  const navigate = useRouterNavigate();

  return (to, options?: NavigateOptions) => {
    if (typeof to === 'string') {
      to = getFullPath(to);
    } else if (typeof to === 'number') {
      return navigate(to);
    }

    navigate(to, options);
  };
}
